export default __webpack_public_path__ + "static/media/profilePic.e36501b8.jpeg";